import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { MESSAGES } from "../../../utlis/messages";

const CHANGE_PASSWORD = `auth/changePassword`

export const changePassword = createAsyncThunk(
  "changePassword",
  async ({ values }: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios('application/json', dispatch).put(CHANGE_PASSWORD, values);
      successMessage( "Password Changed")
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || MESSAGES.SOME_WENT_WRONG);
      return rejectWithValue(error.response.data);
    }
  }
);
